module.exports = __webpack_public_path__ + "static/media/apple.87e1741a.svg";